flagsAreUndefined